import http from '../lib/http-common';
import authHeader from "./authHeader";

let API_URL = process.env.REACT_APP_BACKEND_URL + '/api/user/';

const getUser = () => {
    return http.get(API_URL + "profile", { headers: authHeader() });
};

const getNotifications = () => {
    return http.get(API_URL + "notifications", { headers: authHeader() });
}

const markNotificationsAllRead = () => {
    return http.get(API_URL + "notification/read", { headers: authHeader() });
}

const getDashboardData = () => {
    return http.get(API_URL + "dashboard", { headers: authHeader() });
};

const getUserWallet = () => {
    return http.get(API_URL + "wallet", { headers: authHeader() });
};

const getUserCommission = () => {
    return http.get(API_URL + "commission", { headers: authHeader() });
};

const getUserRewardPts = () => {
    return http.get(API_URL + "reward-pts", { headers: authHeader() });
};

const getSmartPackages = () => {
    return http.get(API_URL + "packages/smart", { headers: authHeader() });
};

const getRetailPackages = () => {
    return http.get(API_URL + "packages/retail", { headers: authHeader() });
};

const getDigitalMarketingPackages = () => {
    return http.get(API_URL + "packages/digital-marketing", { headers: authHeader() });
};

const getVipPackages = () => {
    return http.get(API_URL + "packages/vip", { headers: authHeader() });
};

const getIboPackageswithStatus = () => {
    return http.get(API_URL + "packages/ibo", { headers: authHeader() });
};

const getOtherPackages = () => {
    return http.get(API_URL + "packages/other", { headers: authHeader() });
};

const getNftPackages = () => {
    return http.get(API_URL + "packages/nft", { headers: authHeader() });
}; 

const getJoiningPackage = () => {   
    return http.get(API_URL + "joining-package", { headers: authHeader() });
};

const getShop = () => {
    return http.get(API_URL + "shop", { headers: authHeader() });
};

const getRewards = () => {
    return http.get(API_URL + "my-rewards/reward-pts", { headers: authHeader() });
};

const getCoins = () => {
    return http.get(API_URL + "my-rewards/peacecoins", { headers: authHeader() });
};

const getAllAnnouncements = () => {
    return http.get(API_URL + "announcements", { headers: authHeader() });
};

const getPublicAnnouncements = (page) => {
    return http.get(API_URL + "announcements/public", 
        { 
            headers: authHeader(),
            params: { 
                page: page + 1,
            },
        }
    );
};

const getPrivateAnnouncements = (page) => {
    return http.get(API_URL + "announcements/private", 
        { 
            headers: authHeader(),
            params: { 
                page: page + 1,
            },
        }
    );
};

const getAnnouncementDetails = (slug) => {
    return http.get(API_URL + "announcement/" + slug + "/details", { headers: authHeader() });
};

const getGenealogyTree = (userId) => {
    if(userId) {
        return http.get(API_URL + "network/genealogy/" + userId, { headers: authHeader() });
    } else {
        return http.get(API_URL + "network/genealogy", { headers: authHeader() });
    }
};

const storeNewMember = (data) => {
    return http.post(API_URL + "network/member", data, { headers: authHeader() });
};

const getGenealogyTreeWithSpecificPosition = (userId, position) => {
    return http.get(API_URL + "network/genealogy/" + position + "/tree/" + userId, { headers: authHeader() });
};

const searchUser = (data) => {
    return http.post(API_URL + "network/genealogy/search", data, { headers: authHeader() });
};

const getReferredMembers = () => {
    return http.get(API_URL + "network/referred-members", { headers: authHeader() });
};

const getUsersList = () => {
    return http.get(API_URL + "network/users-list", { headers: authHeader() });
};

const getGenealogySettings = () => {
    return http.get(API_URL + "network/genealogy-settings", { headers: authHeader() });
};

const updateGenealogySettings = (data) => {
    return http.post(API_URL + "network/genealogy-settings", data, { headers: authHeader() });
};

const createPayment = (data) => {
    return http.post(API_URL + "order", data, { headers: authHeader() });
};

const getOrderDetails = (orderId) => {
    return http.get(API_URL + "order/" + orderId + "/details", { headers: authHeader() });
};

const getOrders = () => {
    return http.get(API_URL + "orders", { headers: authHeader() });
};

const getTransactions = () => {
    return http.get(API_URL + "transactions", { headers: authHeader() });
};

const getPackagesForAutoPayments = () => {
    return http.get(API_URL + "auto-payment/packages", { headers: authHeader() });
};

const createAutopaymentSubscription = (data) => {
    return http.post(API_URL + "auto-payment/subscription", data, { headers: authHeader() });
};

const cancelAutopaymentSubscription = (itemId) => {
    return http.get(API_URL + "auto-payment/subscription/" + itemId, { headers: authHeader() });
};

const getUserBonuses = () => {
    return http.get(API_URL + "earnings/bonuses", { headers: authHeader() });
};

const getTrinaryCommission = () => {
    return http.get(API_URL + "earnings/trinary-commission", { headers: authHeader() });
};

const getSupportTickets = (page) => {
    return http.get(API_URL + "support/tickets", 
        { 
            headers: authHeader(),
            params: { 
                page: page + 1,
            },
        }
    );
};

const createSupportTicket = (data) => {
    return http.post(API_URL + "support/ticket", data, { headers: authHeader() });
};

const getTicketDetails = (ticketId) => {
    return http.get(API_URL + "support/ticket/" + ticketId, { headers: authHeader() });
};

const storeTicketReply = (data) => {
    return http.post(API_URL + "support/user/reply", data, { headers: authHeader() });
};

const downloadTicketAttachment = (attachmentId) => {
    return http.get(API_URL + "support/ticket/attachment/" + attachmentId, { headers: authHeader() });
};

const sendReferralInvitation = (data) => {
    return http.post(API_URL + "referral/invitation", data, { headers: authHeader() });
};

const getPeacecoinModules = () => {
    return http.get(API_URL + "pc/modules", { headers: authHeader() });
};

const getModuleAllCourses = (courseId, lang) => {
    return http.get(API_URL + "pc/" + lang + "/module/" + courseId + "/courses", { headers: authHeader() });
};

const getCourseDetails = (lectureId, lang) => {
    return http.get(API_URL + "pc/" + lang + "/course/" + lectureId + "/details", { headers: authHeader() });
};

const getLectureFiles = (fileId, fileCat, lang) => {
    return http.get(API_URL + "pc/" + lang + "/file/" + fileId + "/contents/" + fileCat, { headers: authHeader() });
};

const getCourseQuiz = (courseId, lang) => {
    return http.get(API_URL + "pc/" + lang + "/course/" + courseId + "/quiz", { headers: authHeader() });
};

const submitQuiz = (data) => {
    return http.post(API_URL + "pc/course/quiz", data, { headers: authHeader() });
};

const getQuizResultDetails = (resultId) => {
    return http.get(API_URL + "quiz/result/details/" + resultId, { headers: authHeader() });
};

const getNewModuleCourses = () => {
    return http.get(API_URL + "new/modules", { headers: authHeader() });
};

const getWithdrawsPeacecoins = () => {
    return http.get(API_URL + "withdraws/peace-coins", { headers: authHeader() });
};

const getExecutiveTeam = () => {
    return http.get(API_URL + "team", { headers: authHeader() });
};

const getSuccessProfiles = () => {
    return http.get(API_URL + "success-profiles", { headers: authHeader() });
};

const searchSuccessProfiles = (data) => {
    return http.post(API_URL + "success-profiles/search", data, { headers: authHeader() });
};

const updateUserProfile = (data, userId) => {
    return http.post(API_URL + "profile/" + userId, data, { headers: authHeader() });
};

const updateProfileImage = (data, userId) => {
    return http.post(API_URL + "profile-image/" + userId, data, { headers: authHeader() });
};

const uploadW9Form = (data) => {
    return http.post(API_URL + "w9form", data, { headers: authHeader() });
};

const changePassword = (data) => {
    return http.post(API_URL + "password", data, { headers: authHeader() });
};

const updateEthWallet = (data, userId) => {
    return http.post(API_URL + "eth-wallet/" + userId, data, { headers: authHeader() });
};

const getShippingAddress = () => {
    return http.get(API_URL + "shipping-address", { headers: authHeader() });
};

const createUserShippingAddress = (data) => {
    return http.post(API_URL + "shipping-address/store", data, { headers: authHeader() });
};

const updateUserShippingAddress = (data, userId) => {
    return http.post(API_URL + "shipping-address/" + userId, data, { headers: authHeader() });
};

const userService = {
    getUser,
    getNotifications,
    markNotificationsAllRead,
    getDashboardData,
    getUserWallet,
    getUserCommission,
    getUserRewardPts,
    getSmartPackages,
    getDigitalMarketingPackages,
    getVipPackages,
    getIboPackageswithStatus,
    getOtherPackages,
    getNftPackages,
    getJoiningPackage,
    getShop,
    getRewards,
    getCoins,
    getAllAnnouncements,
    getPublicAnnouncements,
    getPrivateAnnouncements,
    getAnnouncementDetails,
    getGenealogyTree,
    storeNewMember,
    getGenealogyTreeWithSpecificPosition,
    searchUser,
    getReferredMembers,
    getUsersList,
    getGenealogySettings,
    updateGenealogySettings,
    createPayment,
    getOrderDetails,
    getOrders,
    getTransactions,
    getPackagesForAutoPayments,
    createAutopaymentSubscription,
    cancelAutopaymentSubscription,
    getUserBonuses,
    getTrinaryCommission,
    getSupportTickets,
    createSupportTicket,
    getTicketDetails,
    storeTicketReply,
    downloadTicketAttachment,
    sendReferralInvitation,
    getPeacecoinModules,
    getModuleAllCourses,
    getCourseDetails,
    getLectureFiles,
    getCourseQuiz,
    submitQuiz,
    getQuizResultDetails,
    getNewModuleCourses,
    getWithdrawsPeacecoins,
    getExecutiveTeam,
    getSuccessProfiles,
    searchSuccessProfiles,
    updateUserProfile,
    updateProfileImage,
    uploadW9Form,
    changePassword,
    updateEthWallet,
    getShippingAddress,
    createUserShippingAddress,
    updateUserShippingAddress,
    getRetailPackages
};

export default userService;